const currentYear = new Date(Date.now()).getUTCFullYear()
export const FOOTER_STRING_COPYRIGHT = `\u00A9 ${currentYear} Mulligan Funding. All Rights Reserved.`
export const SENTRY_CUSTOMER_PORTAL_APP_ID = '5352551'
export const MULLIGAN_FUNDING_SENTRY_COMPANY_ID =
  'f2fb10cc69484fa9816dcc09e68378ff@o423005'
export const MULLIGAN_PHONE_NUMBER = '(855) 326-3564'
